import { IS_AWS_ENV } from "constants/app.constants";
import styled from "styled-components";

import { WellDetailCardData } from "api/data";

import { NotNormalizableState, PanelErrorState } from "../PanelStates";
import { PerformanceTable } from "../blocks/PerformanceTable";
import { ProductionArrayTable } from "../blocks/ProductionArrayTable";
import { ProductionSummaryTable } from "../blocks/ProductionSummaryTable";
import { ProductionArrayRow } from "../hooks/useProductionArrayData";
import { SNOW, TableFrame } from "../styles";
import { ProductionArrayUnits } from "../utils/productionArray";

export interface ProductionTabProps {
  wellData: Maybe<WellDetailCardData>;
  rows: readonly ProductionArrayRow[];
  units: ProductionArrayUnits;
  hasProduction: boolean;
  rowsFailed: boolean;
  notNormalizable: boolean;
  normalizedBy: Maybe<string>;
  onRetry: () => void;
}

export function ProductionTab({
  wellData,
  rows,
  units,
  hasProduction,
  rowsFailed,
  notNormalizable,
  normalizedBy,
  onRetry
}: ProductionTabProps): JSX.Element {
  if (!hasProduction) return null;

  return (
    <>
      <SummaryBackdrop>
        {IS_AWS_ENV ? (
          <ProductionSummaryTable wellData={wellData} />
        ) : (
          <PerformanceTable wellData={wellData} />
        )}
      </SummaryBackdrop>
      {rowsFailed ? (
        <PanelErrorState
          compact
          title="Could not load the normalized Production Array"
          detail="The normalized request failed. The chart's own data is unaffected."
          onRetry={onRetry}
          testId="well-card-panel-array-error"
        />
      ) : notNormalizable ? (
        <NotNormalizableState />
      ) : (
        <ProductionArrayTable rows={rows} units={units} normalizedBy={normalizedBy} />
      )}
    </>
  );
}

// The same gray as the other summary sections. The table itself stays white so
// its rows still read as a table, like the monthly table below it.
const SummaryBackdrop = styled.div`
  background: ${SNOW};

  ${TableFrame} {
    background: #fff;
  }
`;
